import { theme, ThemeConfig } from 'antd';

const themeConfig: ThemeConfig = {
	hashed: false,
	token: {
		colorBgContainerDisabled: '#F6F6F6',
		colorTextDisabled: '#bababa',
		colorPrimary: '#1557BC',
		fontSize: 16,
		fontFamily:
			"'Myriad Pro', 'Open Sans', 'Poppins', 'Inter', -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol",
	},
	components: {
		Menu: {
			colorBgContainer: 'transparent',
			itemPaddingInline: 8,
			iconSize: 24,
			itemSelectedBg: '#FFF8DD',
			itemSelectedColor: '#C59B04',
			itemMarginInline: 0,
			itemBorderRadius: 0,
			activeBarBorderWidth: 4,
		},
		Layout: {
			bodyBg: '#FAFAFA',
			siderBg: '#FFF',
			headerHeight: 100,
			headerBg: '#1557BC',
			headerPadding: '0 24px',
			headerColor: '#FFF',
			footerPadding: '16px 24px',
		},
		Form: {
			itemMarginBottom: 0,
			labelFontSize: 14,
		},
		Input: {
			colorTextDisabled: '#5f5f5f',
			colorBgContainerDisabled: '#f3f3f3',
		},
		Select: {
			colorTextDisabled: '#5f5f5f',
			colorBgContainerDisabled: '#f3f3f3',
		},
		Table: {
			headerBg: '#FFF8DD',
			headerBorderRadius: 0,
			fontSize: 14,
		},
		Collapse: {
			headerBg: 'transparent',
			headerPadding: '10px 24px',
			contentPadding: 24,
			// colorBorder: '#d9d9d9',
		},
		// Divider: {
		// 	lineWidth: 5,
		// 	colorText: '#888',
		// 	margin: 24,
		// },
	},
};

export default themeConfig;

export const getInitialName = (name: string) => {
	const arr = name.split(' ');
	const firstLetter = name[0][0].toUpperCase();
	const lastLetter = arr.length > 1 && arr[arr.length - 1][0].toUpperCase();
	return lastLetter ? firstLetter + lastLetter : firstLetter;
};

export const getInitialTheme = (name: string) => {
	const initial = getInitialName(name);
	const token = theme.getDesignToken();
	const alphabets = [
		'A',
		'B',
		'C',
		'D',
		'E',
		'F',
		'G',
		'H',
		'I',
		'J',
		'K',
		'L',
		'M',
		'N',
		'O',
		'P',
		'Q',
		'R',
		'S',
		'T',
		'U',
		'V',
		'W',
		'X',
		'Y',
		'Z',
	];

	const themes = [
		'red',
		'magenta',
		'volcano',
		'purple',
		'orange',
		'geekblue',
		'blue',
		'green',
		'cyan',
		'lime',
	] as const;

	const index = alphabets.indexOf(initial[0]) % themes.length;

	return {
		initial,
		style: {
			background: token[`${themes[index]}-7`],
			color: token[`${themes[index]}-1`],
		},
	};
};
